import { createContext, useContext } from 'react';
import { decorateName } from '@unmapped/core/utils';
export var MapContext = decorateName( /*#__PURE__*/createContext(null), 'MapContext');
export var useMap = () => {
  var ctx = useContext(MapContext);
  return {
    map: ctx.mapHandle,
    setHandle: ctx.setMapHandle,
    isLoaded: !!ctx.mapHandle
  };
};
export default useMap;
//# sourceMappingURL=useMap.js.map